import { PowerSyncDatabase } from '@powersync/capacitor'
import { AppSchema } from './schema'
import { setupConnection } from './setup'

// TODO(phase3-emulator-smoke): audit ~35 hook-layer db.execute() call sites
// (useAnalysis, useEmailTemplates, useContractors, etc.) and wrap writes in
// db.writeTransaction. PowerSync Capacitor SDK 0.5.x has restricted Android
// db.execute support per the spike doc — only matters for native runtime.
export function createNativePowerSync(): PowerSyncDatabase | null {
  try {
    console.log('[PS-DIAG] creating PowerSyncDatabase (native)')
    const db = new PowerSyncDatabase({
      schema: AppSchema,
      database: { dbFilename: 'imki.sqlite' },
    })

    // NOTE: we deliberately do NOT set a busy_timeout here. The earlier theory
    // was that "database is locked (code 5)" came from transient WAL contention
    // a busy_timeout would absorb — but (a) `db.execute('PRAGMA busy_timeout=…')`
    // is rejected on Android (the adapter routes non-SELECT writes through
    // executeSet/execSQL, which throws on any result-returning statement), so it
    // never applied to the write connection anyway, and (b) the real cause was a
    // SECOND PowerSyncDatabase being constructed before the first finished
    // closing — the adapter keys native connections by dbFilename, so the new
    // instance force-closes the old one's write connection mid-sync. That's
    // fixed by the single-instance teardown gate in client.ts, not a timeout.

    return setupConnection(db)
  } catch (e) {
    console.error('[PS-DIAG] PowerSyncDatabase init threw', e)
    return null
  }
}
